import request from "../utils/request"

export function fetchProductReviews(params = {}) {
  return request({
    url: "/admin/shop/product-reviews",
    method: "get",
    params
  })
}

export function approveProductReview(id, data = {}) {
  return request({
    url: `/admin/shop/product-reviews/${id}/approve`,
    method: "post",
    data
  })
}

export function rejectProductReview(id, data = {}) {
  return request({
    url: `/admin/shop/product-reviews/${id}/reject`,
    method: "post",
    data
  })
}
